import {PureComponent} from 'react'

import OffersExamples from './OffersExamples.jsx'

import './OffersExamples.scss'

export default class OffersExamplesHr extends PureComponent {
  render() {
    const title = "Ressources Humaines : nos exemples de missions"
    const description = "Retrouvez les différents types de missions RH postés sur notre plateforme : management de transition, interim management, groupe international, ETI, etc."

    return <OffersExamples
      helmet={{title, description}}
      universeCode="hr"
      title="Les missions Ressources Humaines que vous auriez pu recevoir :"
    />
  }
}
